import APP from 'stores/APP';
import { appLinks } from '.';

const isWebview = APP.isWeiXin || APP.isQQ || APP.isWeiBo;

let openInBrowser: HTMLDivElement;

function isDocHidden() {
    // @ts-ignore
    return document.visibilityState === 'hidden' || document.hidden || document.webkitHidden;
}

export function tryDownload(platform: 'ios' | 'android') {
    // 市场唤起链接
    const dlLink = (appLinks.find(t => t.type === platform) || appLinks[0]).url;
    let openBrowserTimer;

    if (!openInBrowser) {
        openInBrowser = document.createElement('div');
        openInBrowser.className = 'dlapp-open-in-browser';
        openInBrowser.innerHTML = `<p>If the download button clicks without skipping, click on the top right menu and select "Open in Browser."</p>`;

        // 将新元素附加到 body 上
        document.body.appendChild(openInBrowser);

        // 添加点击事件监听器
        openInBrowser.addEventListener('click', () => {
            openInBrowser.style.display = 'none';
        });
    }

    /**
     * 如果是在webview，则加个500ms定时器，用于当跳转被webview拦截后，
     * 显示使用浏览器打开的提示
     */
    if (isWebview) {
        openBrowserTimer = setTimeout(() => {
            openInBrowser.style.display = 'block';
        }, 500);
    }

    /**
     * 当页面触发 visibilitychange 事件时，表明唤起跳转应用市场成功
     * 那么就可以取消上面的定时器动作了
     */
    document.addEventListener(
        'visibilitychange',
        () => {
            if (isDocHidden()) {
                clearTimeout(openBrowserTimer);

                openInBrowser.style.display = 'none';
            }
        },
        { once: true }
    );

    window.location.replace(dlLink);
}
